// src/App.js

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import Layout from './pages/Layout.jsx'; // Import the Layout component
import HomePage from './pages/HomePage.jsx';
// Import the component directly from your components folder
import { Questionnaire } from './pages/Questionnaire.jsx';
import NotFoundPage from './components/NotFoundPage';
import './App.css';
import About from './pages/About.jsx';
import GuidesPage from './pages/GuidesPage.jsx';
import Compare from './pages/Compare.jsx';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/questionnaire" element={<Questionnaire />} />
          <Route path="/about" element={<About />} />
          <Route path="/guide" element={<GuidesPage />} />
          <Route path="/compare" element={<Compare />} />
          {/* Add other routes here as needed */}
          {/* Catch-all route for 404 Not Found */}

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
